import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import { useState } from 'react';

const WISE_EMAIL = 'ytproudltd@gmail.com';
const WISE_LINK = 'https://wise.com/pay/business/ytproudllc';
const QR_CODE_URL = 'https://ytproud.com/wp-content/uploads/elementor/thumbs/wise-quick-pay-qr-code-1-qxk8wjwde5a6gli08k64nkr98ke21zlqhafzjp4864.png';
// Use a modern Wise/finance illustration
const WISE_IMAGE_URL = 'https://assets-global.website-files.com/5f6b7190899c3e1a1c8b7b9e/63e3e2b2e2c7e2b2e2c7e2b2_wise-logo.svg';

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
};

const downloadImage = (url, filename) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// --- BankDetailsCards Component ---
const copyIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-green-400 hover:text-green-500 cursor-pointer">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 6v-1.125A2.625 2.625 0 0 0 13.875 2.25h-7.5A2.625 2.625 0 0 0 3.75 4.875v10.5A2.625 2.625 0 0 0 6.375 18H7.5m3 0h7.125A2.625 2.625 0 0 0 20.25 15.375v-7.5A2.625 2.625 0 0 0 17.625 5.25H17.25M9 18a2.25 2.25 0 0 1-2.25-2.25V7.5A2.25 2.25 0 0 1 9 5.25h7.5A2.25 2.25 0 0 1 18.75 7.5v8.25A2.25 2.25 0 0 1 16.5 18H9Z" />
  </svg>
);

const usdDetails = {
  local: [
    { label: 'Wise Account Holder', value: 'YTproud LLC' },
    { label: 'Account holder', value: 'Wise US Inc.' },
    { label: 'ACH and Wire routing number', value: '084009519' },
    { label: 'Account number', value: '119835591292591' },
    { label: 'Account type', value: 'Checking' },
    { label: 'Bank name and address', value: 'Column National Association, A4-700 1 Letterman Drive, San Francisco CA 94129, United States' },
  ],
  global: [
    { label: 'Wise Account Holder', value: 'YTproud LLC' },
    { label: 'Account holder', value: 'Wise US Inc.' },
    { label: 'Swift/BIC', value: 'TRWIUS35XXX' },
    { label: 'Account number', value: '119835591292591' },
    { label: 'Bank name and address', value: 'Wise US Inc, 30 W. 26th Street, Sixth Floor, New York NY 10010, United States' },
  ],
  info: [
    "Local: There's a 6.11 USD fee to receive wire transfers. Payments take up to 3 working days to arrive.",
    "Global · Swift: Payments take up to 5 working days to arrive. There's a 6.11 USD fee to receive wire transfers."
  ]
};

const gbpDetails = {
  local: [
    { label: 'Account holder', value: 'YTproud LLC' },
    { label: 'Sort code', value: '23-08-01' },
    { label: 'Account number', value: '96652228' },
    { label: 'IBAN', value: 'GB97 TRWI 2308 0196 6522 28' },
    { label: 'Bank name and address', value: 'Wise Payments Limited, 56 Shoreditch High Street, London, E1 6JJ, United Kingdom' },
  ],
  global: [
    { label: 'Account holder', value: 'YTproud LLC' },
    { label: 'Swift/BIC', value: 'TRWIGB2LXXX' },
    { label: 'IBAN', value: 'GB97 TRWI 2308 0196 6522 28' },
    { label: 'Bank name and address', value: 'Wise Payments Limited, 56 Shoreditch High Street, London, E1 6JJ, United Kingdom' },
  ],
  info: [
    "Local: Payments take up to 1 working day to arrive.",
    "Global · Swift: Payments take up to 5 working days to arrive. Receive payments in 22 other currencies with these details. Fees apply."
  ]
};

function BankDetailsCards() {
  const [usdTab, setUsdTab] = useState('local');
  const [gbpTab, setGbpTab] = useState('local');
  const [notification, setNotification] = useState('');

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setNotification('Copied to clipboard!');
    setTimeout(() => setNotification(''), 2000);
  };

  const handleCopyAll = (region, tab) => {
    const details = (region === 'usd' ? usdDetails : gbpDetails)[tab]
      .map(row => `${row.label}: ${row.value}`)
      .join('\n');
    handleCopy(details);
  };

  return (
    <div className="flex flex-col md:flex-row gap-8 justify-center items-stretch">
      {/* USD Card */}
      <div className="flex-1 min-w-[320px] max-w-xl bg-[#121212] rounded-2xl shadow-2xl p-6 md:p-8 flex flex-col">
        <div className="flex justify-between items-center bg-[#1a1a1a] rounded-lg px-4 py-2 mb-4">
          <div className="flex items-center gap-2 text-lg font-bold text-white"><span role="img" aria-label="globe">🌐</span>Receive from a bank outside the US</div>
          <button className="bg-green-500 hover:bg-green-600 text-black font-semibold px-4 py-1 rounded-full text-xs" onClick={() => handleCopyAll('usd', usdTab)}>Copy All</button>
        </div>
        <div className="flex gap-2 mb-4 bg-[#1a1a1a] rounded-lg p-1">
          <button className={`flex-1 py-2 rounded-full text-sm font-semibold transition ${usdTab === 'local' ? 'bg-green-500 text-white' : 'text-gray-300'}`} onClick={() => setUsdTab('local')}>Local</button>
          <button className={`flex-1 py-2 rounded-full text-sm font-semibold transition ${usdTab === 'global' ? 'bg-green-500 text-white' : 'text-gray-300'}`} onClick={() => setUsdTab('global')}>Global · Swift</button>
        </div>
        <div className="flex-1">
          {(usdDetails[usdTab]).map((row, i) => (
            <div className="mb-4" key={row.label}>
              <div className="font-bold text-base mb-1 text-white">{row.label}</div>
              <div className="flex items-center justify-between text-base bg-transparent text-white">
                <span className="break-all">{row.value}</span>
                <span onClick={() => handleCopy(row.value)}>{copyIcon}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-[#1a1a1a] rounded-lg p-4 mt-auto text-sm text-white">
          <div>{usdDetails.info[0]}</div>
          <div className="mt-1">{usdDetails.info[1]}</div>
        </div>
      </div>
      {/* GBP Card */}
      <div className="flex-1 min-w-[320px] max-w-xl bg-[#121212] rounded-2xl shadow-2xl p-6 md:p-8 flex flex-col">
        <div className="flex justify-between items-center bg-[#1a1a1a] rounded-lg px-4 py-2 mb-4">
          <div className="flex items-center gap-2 text-lg font-bold text-white"><span role="img" aria-label="globe">🌐</span>Receive from a bank in the UK</div>
          <button className="bg-green-500 hover:bg-green-600 text-black font-semibold px-4 py-1 rounded-full text-xs" onClick={() => handleCopyAll('gbp', gbpTab)}>Copy All</button>
        </div>
        <div className="flex gap-2 mb-4 bg-[#1a1a1a] rounded-lg p-1">
          <button className={`flex-1 py-2 rounded-full text-sm font-semibold transition ${gbpTab === 'local' ? 'bg-green-500 text-white' : 'text-gray-300'}`} onClick={() => setGbpTab('local')}>Local</button>
          <button className={`flex-1 py-2 rounded-full text-sm font-semibold transition ${gbpTab === 'global' ? 'bg-green-500 text-white' : 'text-gray-300'}`} onClick={() => setGbpTab('global')}>Global · Swift</button>
        </div>
        <div className="flex-1">
          {(gbpDetails[gbpTab]).map((row, i) => (
            <div className="mb-4" key={row.label}>
              <div className="font-bold text-base mb-1 text-white">{row.label}</div>
              <div className="flex items-center justify-between text-base bg-transparent text-white">
                <span className="break-all">{row.value}</span>
                <span onClick={() => handleCopy(row.value)}>{copyIcon}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-[#1a1a1a] rounded-lg p-4 mt-auto text-sm text-white">
          <div>{gbpDetails.info[0]}</div>
          <div className="mt-1">{gbpDetails.info[1]}</div>
        </div>
      </div>
      {/* Notification */}
      {notification && (
        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 bg-white text-black px-6 py-3 rounded-lg shadow-lg z-50 text-base font-semibold animate-fade-in">
          {notification}
        </div>
      )}
    </div>
  );
}

const WisePaymentDetails = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <SEOHead
        title="Wise & Bank Transfer Payment Details | YTProud"
        description="Complete your payment securely using Wise or direct bank transfer. Get USD and GBP account details, QR codes, and payment instructions for YTProud."
        keywords="wise payment, bank transfer, USD account, GBP account, payment details, secure payment, ytproud payment"
        canonical="https://ytproud.com/wise-payment-details"
        ogTitle="Wise & Bank Transfer Payment Details | YTProud"
        ogDescription="Complete your payment securely using Wise or direct bank transfer. Get USD and GBP account details, QR codes, and payment instructions."
        ogImage="/images/wise-payment.jpg"
        twitterTitle="Wise & Bank Transfer Payment Details | YTProud"
        twitterDescription="Complete your payment securely using Wise or direct bank transfer. Get USD and GBP account details, QR codes, and payment instructions."
        twitterImage="/images/wise-payment.jpg"
        schemaJsonLd={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Wise & Bank Transfer Payment Details",
          "description": "Complete your payment securely using Wise or direct bank transfer",
          "url": "https://ytproud.com/wise-payment-details",
          "mainEntity": {
            "@type": "Organization",
            "name": "YTProud",
            "url": "https://ytproud.com"
          }
        }}
      />
      <Header />
      <main className="flex-grow container mx-auto px-2 py-10">
        {/* Top Box */}
        <div className="bg-[#101624] rounded-3xl p-10 flex flex-col md:flex-row items-center justify-between mb-12 shadow-2xl">
          <div className="flex-1 text-center md:text-left">
            <h1 className="text-5xl font-extrabold text-white mb-5">Wise & bank Transfer</h1>
            <p className="text-gray-200 text-lg mb-5">
              Easily and securely complete your payment using Wise or a direct bank transfer. Follow the payment details provided below to proceed.
            </p>
            <p className="text-red-500 font-semibold text-base">
              Note: When making your payment, please ensure you enter the full price of the account you are purchasing to avoid any delays in completing your transaction. And send your payment slip through live chat.
            </p>
          </div>
          <div className="mt-8 md:mt-0 md:ml-12 flex-shrink-0 flex items-center justify-center">
            {/* Modern payment/bank transfer SVG icon */}
            <div className="bg-white rounded-xl p-4 shadow-lg flex items-center justify-center w-44 h-28">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="10" y="20" width="60" height="40" rx="8" fill="#22c55e"/>
                <rect x="18" y="28" width="44" height="24" rx="4" fill="#fff"/>
                <path d="M28 40h24M40 32v16" stroke="#22c55e" strokeWidth="3" strokeLinecap="round"/>
                <circle cx="40" cy="40" r="6" fill="#22c55e" stroke="#22c55e" strokeWidth="2"/>
                <path d="M40 36v8M36 40h8" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Second Box */}
        <div className="bg-[#181f32] rounded-3xl p-10 flex flex-col md:flex-row items-center justify-center shadow-2xl gap-10">
          {/* QR Code Section */}
          <div className="flex flex-col items-center">
            <div className="bg-[#232b43] rounded-2xl p-3 mb-4 shadow-lg">
              <img src={QR_CODE_URL} alt="Wise QR Code" className="w-36 h-36 object-contain" />
            </div>
            <button
              className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-8 rounded-full focus:outline-none focus:ring-2 focus:ring-green-400 text-lg shadow-md"
              onClick={() => downloadImage(QR_CODE_URL, 'wise-qr-code.png')}
            >
              Download
            </button>
          </div>

          {/* Email Section */}
          <div className="flex-1 flex flex-col items-center">
            <div className="bg-[#232b43] rounded-2xl p-8 w-full max-w-lg flex flex-col items-center shadow-lg">
              <span className="text-white text-xl font-bold mb-4 text-center">wise Email - {WISE_EMAIL}</span>
              <button
                className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-12 rounded-full focus:outline-none focus:ring-2 focus:ring-green-400 text-lg shadow-md"
                onClick={() => copyToClipboard(WISE_EMAIL)}
              >
                Copy Email
              </button>
            </div>
          </div>

          {/* Link Section */}
          <div className="flex-1 flex flex-col items-center">
            <div className="bg-[#232b43] rounded-2xl p-8 w-full max-w-lg flex flex-col items-center shadow-lg">
              <span className="text-white text-xl font-bold mb-4 text-center break-all">{WISE_LINK}</span>
              <div className="flex gap-4">
                <button
                  className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-10 rounded-full focus:outline-none focus:ring-2 focus:ring-green-400 text-lg shadow-md"
                  onClick={() => copyToClipboard(WISE_LINK)}
                >
                  Copy Link
                </button>
                <a
                  href={WISE_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-10 rounded-full focus:outline-none focus:ring-2 focus:ring-green-400 text-lg shadow-md text-center"
                >
                  Open Link
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* Bank Details Section */}
      <section className="container mx-auto px-2 pb-12">
        <h2 className="text-2xl md:text-3xl font-extrabold text-center mb-8 mt-2">USD Account Details & GBP Account Details</h2>
        <BankDetailsCards />
      </section>
      <Footer />
    </div>
  );
};

export default WisePaymentDetails; 